<template>
  <el-card
    id="ysMonitorId"
    class="ys-monitor-wrapper flex-1 h-full"
    :body-style="{ height: '100%' }"
  >
    <div class="flex flex-col h-full">
      <TitleBorder title="实时监控画面" class="h-18px"></TitleBorder>

      <div class="h-[calc(100%-28px)]">
        <YSPlayer
          :code="playerInfo.code"
          :pIid="playerInfo.pIid"
          v-if="!isUseNewVersion && playerInfo.code"
        ></YSPlayer>
        <MultiYSMonitor
          v-if="isUseNewVersion && playerInfo.code"
          ref="MultiYSMonitorRef"
          class="w-full h-full"
          :defaultMonitorList="monitorList"
        ></MultiYSMonitor>
      </div>
    </div>
  </el-card>
</template>

<script>
import YSPlayer from '@/components/video/YSPlayer/YSPlayer'
import TitleBorder from '@/components/TitleBorder'
import MultiYSMonitor from './MultiYSMonitor'
// import NewYSPlayer from '@/components/video/YSPlayer/NewYSPlayer'
// import MonitorEmpty from './MonitorEmpty'

export default {
  name: 'ysMonitor',
  components: {
    // MonitorEmpty,
    // NewYSPlayer,
    YSPlayer,
    TitleBorder,
    MultiYSMonitor,
  },
  data() {
    return {
      playerInfo: {},
      monitorList: [],
    }
  },
  methods: {
    playVideo(info) {
      this.playerInfo = info
      this.$nextTick(() => {
        this.$refs?.MultiYSMonitorRef?.playVideo(info)
      })
    },
    setMonitorList(monitorList) {
      this.monitorList = monitorList
    },
  },
  computed: {
    // 是否使用新版的宇视
    isUseNewVersion() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["wiz-iot-management-tongre"].config')
          ?.NewYSPlayerConfig?.isUseNewYS || false
      )
    },
  },
}
</script>
